import { Component, OnInit, inject } from '@angular/core';
import { Title } from '@angular/platform-browser';
import { ActivatedRoute, NavigationEnd, Router, RouterOutlet } from '@angular/router';
import { LocalAuthService, TokenRefreshComponent } from '@buspro/web/core';
// import { AngularQueryDevtools } from '@tanstack/angular-query-devtools-experimental';
import { NgxAuthService } from '@corelabs/ng-auth';
import { UntilDestroy, untilDestroyed } from '@ngneat/until-destroy';
import { LoadingBarHttpClientModule } from '@ngx-loading-bar/http-client';
import { NGXLogger } from 'ngx-logger';
import { filter, map, mergeMap } from 'rxjs';

@UntilDestroy()
@Component({
  selector: 'buspro-root',
  standalone: true,
  imports: [RouterOutlet, LoadingBarHttpClientModule, TokenRefreshComponent],
  template: `
    <main>
      <ngx-loading-bar color="red"></ngx-loading-bar>
      <!-- <buspro-token-refresh></buspro-token-refresh> -->
      <router-outlet #o="outlet"></router-outlet>
      <!--      <angular-query-devtools [initialIsOpen]="false" />-->
    </main>
  `,
})
export class AppComponent implements OnInit {
  private ngxAuthService = inject(NgxAuthService);
  private authService = inject(LocalAuthService);

  private logger = inject(NGXLogger);
  authUser$ = this.authService.currentUser$;

  constructor(
    private router: Router,
    private activatedRoute: ActivatedRoute,
    private titleService: Title,
  ) {
    // Auth initialization is now handled by APP_INITIALIZER
    // No need to call initialize() here anymore
  }

  ngOnInit(): void {
    // Icons are now loaded dynamically on-demand via assets configuration
    this.router.events
      .pipe(
        filter((event) => event instanceof NavigationEnd),
        map(() => this.activatedRoute),
        map((route) => {
          let currentRoute = route;
          while (currentRoute.firstChild) {
            currentRoute = currentRoute.firstChild;
          }
          return currentRoute;
        }),
        map((route) => {
          let currentRoute = route;
          while (currentRoute.firstChild) {
            currentRoute = currentRoute.firstChild;
          }
          // this.authService.setInterruptedUrl(this.router.url);
          return currentRoute;
        }),
        filter((route) => route.outlet === 'primary'),
        mergeMap((route) => route.data),
      )
      .pipe(untilDestroyed(this))
      .subscribe((event) => {
        this.titleService.setTitle(`BusPro Admin | ${event['title']}`);
      });
  }
}
